import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import Component from 'react-pure-render/component';

export class LicitacaoDetalheRecurso extends Component {
  static propTypes = {
    recursos: PropTypes.object.isRequired,
    onDownload: PropTypes.func.isRequired,
    isIntegradoOxy: PropTypes.bool.isRequired
  };

  verificaArquivo = data => {
    if (data.get('arquivos').size != 0) {
      return <td> {data.get('arquivos').map(this.renderArquivo)}</td>;
    }
    return <td>Sem Arquivos</td>;
  };

  renderArquivo = arquivo => {
    const { onDownload } = this.props;

    const downloadArquivo = () => {
      return onDownload(arquivo.get('idArquivo'));
    };

    return (
      <div key={arquivo.get('idArquivo')} style={{ marginTop: '3px' }}>
        <a style={{ cursor: 'pointer' }} onClick={downloadArquivo}>
          <i className="fa fa-download" style={{ marginRight: '5px' }} />
          {arquivo.get('nomeArquivo')}
        </a>
      </div>
    );
  };

  renderRecurso = data => {
    const { isIntegradoOxy } = this.props;

    const key =
      data.get('id') +
      '_' +
      data.get('tipo') +
      '_' +
      data.get('data') +
      '_' +
      data.get('analise');

    return (
      <TableActions ref="row" key={key} data={data.get('id')}>
        <td>{DateUtils.formatDateTimeShort(data.get('data'))}</td>
        <td>{data.get('tipo')}</td>
        {!isIntegradoOxy && <td>{data.get('numeroProtocolo')}</td>}
        {!isIntegradoOxy && (
          <td>{DateUtils.formatDateTimeShort(data.get('dataProtocolo'))}</td>
        )}
        <td>{data.get('analise')}</td>
        {this.verificaArquivo(data)}
      </TableActions>
    );
  };

  render() {
    const { recursos, isIntegradoOxy } = this.props;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={recursos.isEmpty()}>
            <tr>
              <th>Data</th>
              <th>Tipo</th>
              {!isIntegradoOxy && <th>Número Protocolo</th>}
              {!isIntegradoOxy && <th>Data Protocolo</th>}
              <th>Análise</th>
              <th>Arquivos</th>
            </tr>
          </TableHeader>
          <tbody>{recursos.map(this.renderRecurso)}</tbody>
        </table>
      </div>
    );
  }
}

export default LicitacaoDetalheRecurso;
